import { css } from '@emotion/react';
import { Colors, media } from '@utex/ui-kit';

export const style = css`
  width: 100%;
  margin: 0;
  padding: 2rem var(--gap) 1.6rem;
  border-bottom: 1px solid ${Colors.ut.border10};

  @media ${media.phonablet} {
    padding-top: 1.8rem;
    padding-bottom: 1.2rem;
    border-bottom: 0;
  }
`;
